<template>
  <div class="payment-data">
    <div class="payment-container">
      <template v-if="loading">
        <loader :light="true" style="height: 40px"/>
      </template>
      <template v-if="!loading && !hasCard">
        <h6>{{$t('card-payment.cards')}}</h6>
        <span class="information-message">{{$t('step4.payment.noCard')}}</span>
        <div class="button-center">
          <button @click="openModal()" class="total-btn-white">
            {{$t('step4.payment.addCard')}}
          </button>
        </div>
      </template>
      <div class="grid-info" v-if="!loading && hasCard">
        <div class="card-list">
          <h6>{{ $t('step4-multi.booking-room.my-card') }}</h6>
          <credit-card v-for="(item, index) in onlyMainCards" :index="index" :key="item.getId()" :item="item" :data="item"/>
        </div>
        <div class="card-list">
          <h6>{{ $t('step4-multi.booking-room.manage-cards') }}</h6>
          <credit-card v-for="(item, index) in onlySecondaryCards" :index="index" :key="item.getId()" :item="item" :data="item"/>
          <div class="button-center">
            <button @click="openModal()" class="total-btn-white">
              {{$t('step4.payment.addCard')}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <add-card-modal :opened="modalOpenState" @close="handleModalClose"/>
  </div>

</template>

<style scoped>
  #paymentform .field {
    margin-bottom: 12px!important;
    max-width: 455px;
  }
</style>
<script>
  import CreditCard from '../../../components/credit-card';
  import AddCardModal from '../../client/part/add-card-modal';
  import Loader from '../../../components/loader.component';
  import { mapState } from 'vuex';
  import CheckboxInput from '../../../components/checkbox-input';
  import SaveCardInput from "../../../components/save-card-input";

  export default {
    name: 'step4-paiment-informations',
    components: {SaveCardInput, CheckboxInput, Loader, AddCardModal, CreditCard },
    props: {
      bookingId: {
        required: true,
      }
    },
    computed: {
      hasCard() {
        return this.cards && this.cards.length > 0 && this.cards[0].getLast4();
      },
      last4() {
        if (this.hasCard) {
          return this.cards[0].getLast4();
        }
        return null;
      },
      needVerification () {
        return false; // chercher dans le priceplan
      },
      ...mapState({
        loading: s => s.stripeCard.loading,
        cards: s => s.stripeCard.cards.sort((a, b) => (a.isMain() ? -1 : 1)),
        disabled: s => !Object.keys(s.bookingStep4.form).reduce((p, n) => (p && s.bookingStep4.form[n]), true), // changer le store
        rooms: s => s.shoppingCart.shoppingCart.bookings // changer la valeur
      }),
      onlyMainCards() {
        return this.cards.filter(c => c.isMain());
      },
      onlySecondaryCards() {
        return this.cards.filter(c => !c.isMain());
      },
      totalPrice() {
        return 0; // total price du booking en cours
      }
    },
    data() {
      return {
        panelOpen: false,
        modalOpenState: false,
      };
    },
    async mounted() {
      await this.fetchCards();
    },
    methods: {
      async fetchCards() {
        await this.$store.dispatch('stripeCard/fetch');
        if (this.hasCard) {
          this.$store.commit('shoppingCart/booking/personal/SET_HAS_CARD', true);
          this.$store.commit('shoppingCart/booking/personal/SET_DATA_CARD', this.cards[0]);
          return;
        }
        this.$store.commit('shoppingCart/booking/personal/SET_HAS_CARD', false);
        this.$store.commit('shoppingCart/booking/personal/SET_DATA_CARD', null);
      },
      async handleModalClose(e) {
        this.modalOpenState = false;
        if (e && e.success) {
          await this.fetchCards();
        }
      },
      openPanel() {
        this.panelOpen = this.panelOpen !== true;
      },
      openModal() {
        this.modalOpenState = true;
      },
      send(e) {
        e.preventDefault();
        if (this.disabled) return;
        if (this.needVerification === true) {
          window.dispatchEvent(new Event('app:payment-verification-modal.open'));
          return;
        }
        this.$store.commit('bookingStep4/SET_MODAL_OPEN_STATE', true)
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/tunnel/step4-multi/step4-paiment-informations.vue